import axios from 'axios'

/** Share in-flight company fetches so login + app mount don't refresh SM8 twice. */
const inFlightByCompany = new Map()

export function loadCompanyIntegrations (store) {
  if (!store || !store.getters) return Promise.resolve()
  const profile = store.getters['user/getProfile'] || {}
  const companyId = Number(profile.company_id)
  if (!Number.isInteger(companyId) || companyId < 1) return Promise.resolve()

  const existing = inFlightByCompany.get(companyId)
  if (existing) return existing

  const promise = axios.get('/api/company/' + companyId).then((response) => {
    if (response.data && response.data.company) {
      store.commit('company/setProfile', response.data.company)
    }
    if (response.data && response.data.integrations) {
      store.commit('company/setIntegrations', response.data.integrations)
    }
  }).catch(() => {}).finally(() => {
    if (inFlightByCompany.get(companyId) === promise) {
      inFlightByCompany.delete(companyId)
    }
  })

  inFlightByCompany.set(companyId, promise)
  return promise
}
